import { apiClient } from 'pobble-components/dist/api'
import { useState, useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

// Module-level cache for the fetched data
let freePromptsCache = null

export function useQuery() {
  const { search } = useLocation()

  return useMemo(() => new URLSearchParams(search), [search])
}

export const useFreePrompts = () => {
  const [freePromptsId, setFreePromptsId] = useState(null)

  useEffect(() => {
    // If we have cached data, use it instead of fetching again
    if (freePromptsCache) {
      setFreePromptsId(freePromptsCache)
      return
    }

    Promise.all([
      apiClient.get('/v3/p365/today', { params: { count: 1, from: 0 } }),
      apiClient.get('/v3/presentations/search', {
        params: { recommended: true, from: 0, limit: 0 }
      }),
      apiClient.get('/v3/presentations/search', {
        params: { search_string: 'chocolate', from: 0, limit: 12 }
      })
    ]).then(([p365, weekly, topics]) => {
      const promptIds = new Set()
      promptIds.add(p365.data.presentations[0]?.id)
      promptIds.add(weekly.data.presentations[0]?.id)
      topics.data.presentations.forEach(p => promptIds.add(p.id))

      // Cache the data before setting state
      freePromptsCache = promptIds
      setFreePromptsId(promptIds)
    })
  }, [])

  return freePromptsId
}

export default useFreePrompts
